import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import PrescriberCodeStepOne from './PrescriberCodeStepOne'
import PrescriberCodeStepTwo from './PrescriberCodeStepTwo'
import { resetAuthError, authFail } from 'store/actions'

const prescriberSteps = {
  one: PrescriberCodeStepOne,
  two: PrescriberCodeStepTwo,
}

const SignupStepZero = (props) => {
  const [prescriberStep, setPrescriberStep] = useState('one')
  const [prescriberCode, setPrescriberCode] = useState('')
  const [signupWithoutPrescriberCode, setSignupWithoutPrescriberCode] = useState(false)

  const searchParams = new URLSearchParams(location.search)
  const prescriberCodeParam = [...searchParams].find(
    ([key]) => key === 'prescriberCode'
  )?.[1]
  const prescriberCodeIsValid = /^[A-Z0-9]{6,10}$/i.test(prescriberCodeParam)

  useEffect(() => {
    if (prescriberCodeParam && prescriberCodeIsValid) {
      setPrescriberCode(prescriberCodeParam.toUpperCase())
      setSignupWithoutPrescriberCode(true)
      setPrescriberStep('two')
    }
  }, [])

  const PrescriberCodeStep = prescriberSteps[prescriberStep]

  return (
    <>
      <PrescriberCodeStep
        setPrescriberStep={(newPrescriberStep) => {
          Object.keys(prescriberStep).includes(newPrescriberStep)
          setPrescriberStep(newPrescriberStep)
        }}
        authFail={props.authFail}
        resetAuthError={props.resetAuthError}
        prescriberCodeParam={prescriberCode}
        setPrescriberCode={(newPrescriberCode) => {
          Object.keys(prescriberCode).includes(newPrescriberCode)
          setPrescriberCode(newPrescriberCode)
        }}
        signupWithoutPrescriberCode={signupWithoutPrescriberCode}
        setSignupWithoutPrescriberCode={(withoutPrescriberCode) => {
          Object.keys(signupWithoutPrescriberCode).includes(withoutPrescriberCode)
          setSignupWithoutPrescriberCode(withoutPrescriberCode)
        }}
      />
    </>
  )
}

const mapStateToProps = ({
  auth: { attributes, error, loading, isAuthenticated, isDoctor },
}) => {
  return {
    attributes,
    loading,
    isAuthenticated,
    isDoctor,
    authError: error,
  }
}

const willMapDispatchToProps = {
  authFail,
  resetAuthError,
}

export default connect(mapStateToProps, willMapDispatchToProps)(SignupStepZero)
